import request from './request'

/**
 * 获取版本信息
 * @param {string} data 请求版本
 */
export function getVersion(data) {
  return request.get('/win_api_getVersion.php', {
    params: data
  })
}

/**
 * 下载后，记录下载信息
 * @param {string} data 记录下载信息
 */
export function getDownload(data) {
  return request.get('/win_api_download.php', {
    params: data
  })
}
